import { decorate, observable, action } from 'mobx';

import Api from '../api';

const getDismissKey = (customerId, userId) => `migration_notice_dismissed_${customerId || 'global'}_${userId || 'unknown'}`;

const getCurrentWeekMonday = () => {
  const now = new Date();
  const monday = new Date(now);
  monday.setDate(now.getDate() - ((now.getDay() + 6) % 7));
  return `${monday.getFullYear()}-${String(monday.getMonth() + 1).padStart(2, '0')}-${String(monday.getDate()).padStart(2, '0')}`;
};

class MigrationStore {
  isMigrated = false;

  showTargetUrl = false;

  showMaintenancePage = false;

  targetUrl = null;

  headerAlternate = null;

  secondaryLoginMessageHtml = null;

  targetUrlSecondaryLogin = null;

  isFetching = false;

  adminNoticeDismissed = false;

  async fetchMigrationStatus() {
    this.isFetching = true;
    try {
      const { data } = await Api.getMigrationStatus();
      this.isMigrated = data?.isMigrated ?? false;
      this.showTargetUrl = data?.showTargetUrl ?? false;
      this.showMaintenancePage = data?.showMaintenancePage ?? false;
      this.targetUrl = data?.targetUrl ?? null;
      this.headerAlternate = data?.headerAlternate ?? null;
      this.secondaryLoginMessageHtml = data?.secondaryLoginMessageHtml ?? null;
      this.targetUrlSecondaryLogin = data?.targetUrlSecondaryLogin ?? null;
    } catch (e) {
      // Non-migrated customers will 404 or return isMigrated: false — fail silently.
    } finally {
      this.isFetching = false;
    }
  }

  isNoticeDismissed(customerId, userId) {
    try {
      const stored = localStorage.getItem(getDismissKey(customerId, userId));
      return stored === getCurrentWeekMonday();
    } catch {
      return false;
    }
  }

  loadDismissedState(customerId, userId) {
    this.adminNoticeDismissed = this.isNoticeDismissed(customerId, userId);
  }

  dismissAdminNotice(customerId, userId) {
    try {
      localStorage.setItem(getDismissKey(customerId, userId), getCurrentWeekMonday());
    } catch {
      // localStorage unavailable — fail silently
    }
    this.adminNoticeDismissed = true;
  }
}

decorate(MigrationStore, {
  isMigrated: observable,
  showTargetUrl: observable,
  showMaintenancePage: observable,
  targetUrl: observable,
  headerAlternate: observable,
  secondaryLoginMessageHtml: observable,
  targetUrlSecondaryLogin: observable,
  isFetching: observable,
  adminNoticeDismissed: observable,
  fetchMigrationStatus: action,
  loadDismissedState: action,
  dismissAdminNotice: action,
  isNoticeDismissed: action,
});

export default new MigrationStore();
